// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchButton_root__KmoWT","iconSearchContainer":"SearchButton_iconSearchContainer__2aadl","iconSearch":"SearchButton_iconSearch__bwiXG"};